import { ChangeEvent, FormEvent, useEffect, useRef, useState } from "react";
import { IEquipoDTO, IEquipoRequest, IVisibilidad, InitialEquipoRequest } from "../../../Interfaces/IEquipo";
import { HistoricoEstadoEquipoService } from "../../../services/auxiliar/HistoricoEstadoEquipo";
import { ISearchBox } from "@fluentui/react";
import EquipoService from "../../../services/ListaVerificacion/EquipoService";
import { IResponseApiFluent } from "../../../Interfaces/base/IResponse";
import { IPaginationV2 } from "../../../Interfaces/base/ITable";

export type keyType = "turnoKey" | "razonKey" | "ubicacionKey" | "equipoKey" | "tipoEquipoKey"
export type textType = "tuernoText" | "razonText" | "ubicacionText" | "equipoText" | "tipoEquipoText"


export interface IFilter2 {
    turnoKey: string,
    tuernoText: string
    razonKey: string,
    razonText: string
    ubicacionKey: string,
    ubicacionText: string
    equipoKey: string,
    equipoText: string,
    tipoEquipoKey:string,
    tipoEquipoText:string
}

const initialFilter2: IFilter2 = {
    turnoKey: "",
    tuernoText: "",
    razonKey: "",
    razonText: "",
    ubicacionKey: "",
    ubicacionText: "",
    equipoKey: "",
    equipoText: "",
    tipoEquipoKey:"",
    tipoEquipoText:""
}

export interface IT {
    key: keyType, keyValue: string, text: textType, textValue: string
}

const UseEquipo = () => {
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [items, setItems] = useState<IEquipoDTO[]>([]);
    const onChangeSearch = useRef<ISearchBox>(null);
    const [control, setControl] = useState(true);
    const [filter2, setFilter2] = useState<IFilter2>({ ...initialFilter2 });
    const [filter, setFilter] = useState<IEquipoRequest>(InitialEquipoRequest);

    const onChangeComboFilter = ({ key, keyValue, text, textValue }: IT) => {
        setFilter2(prevState => ({
            ...prevState,
            [key]: keyValue,
            [text]: textValue,
        }));
    };

    const buscar = () => {
        setFilter({
            skip: 0,
            take: 50,
            search: "",
            razonId: (filter2.razonKey != "") ? filter2.razonKey : undefined,
            turnoId: (filter2.turnoKey != "") ? filter2.turnoKey : undefined,
            ubicacionId: (filter2.ubicacionKey != "") ? filter2.ubicacionKey : undefined,
            equipoId: (filter2.equipoKey != "") ? filter2.equipoKey : undefined,
            tipoEquipoId: (filter2.tipoEquipoKey != "") ? filter2.tipoEquipoKey : undefined,
        })
        setControl(true);
    }

    const resetFilter2 = () => {
        setFilter2({ ...initialFilter2 });
        setFilter({
            skip: 0,
            take: 50,
            search: "",
            razonId: undefined,
            turnoId: undefined,
            ubicacionId: undefined,
            equipoId: undefined,
            tipoEquipoId: undefined
        })
        setControl(true);
    };

    const initial: IEquipoRequest = {
        skip: 0,
        take: 50
    };

    const _onkeyUpSearchTable = (event: React.KeyboardEvent<HTMLInputElement>) => {
        let { value } = event.target as HTMLInputElement;
        setFilter(prev => ({ ...prev, search: value, skip: 0 }));
        setControl(true);
    };

    const onChangeTake = (value: number) => {
        setFilter(prev => ({ ...prev, take: value, skip: 0 }));
        setControl(true);
    };

    const onSkip = (value: number) => {
        setFilter(prev => {
            const realSkip = (value * prev.take) - prev.take;
            return { ...prev, skip: realSkip };
        });
        setControl(true);
    };

    const [pagination, setPagination] = useState<IPaginationV2>({
        currentPage: 0,
        total: 0,
        pageSize: 0,
        skip: 0,
        take: 50,
        onPageChange: onSkip,
        onSizeChange: onChangeTake
    });

    const handleResetUpdate = () => {
        setFilter(initial);
        setControl(true);
    };

    const getEquipo = () => {
        setLoading(true);
        HistoricoEstadoEquipoService.ListarHistoricoEquipo(filter)
            .then((res) => {
                setPagination(prevPag => ({
                    ...prevPag,
                    currentPage: res.data.page,
                    total: res.data.total,
                    pageSize: res.data.pages,
                    skip: filter.skip,
                    take: filter.take,
                }));
                setItems(res.data.items);
                setLoading(false);
            })
            .catch((e: any) => {
                setLoading(false);
            });
    };

    // Manejo de la visibilidad de los equipos
    const handleSelectAllChange = (
        checked: boolean,
        equipoId: string,
        ev: FormEvent<HTMLInputElement | HTMLElement> | undefined
    ) => {
        if (ev) {
            const request: IVisibilidad = {
                equipoId: equipoId,
                check: checked
            };
            EquipoService.PutActualizarVisibilidad(request).then((res) => {
                if (res.status === 200) {
                    setItems((prevItems) =>
                        prevItems.map((item) =>
                            item.equipoId === equipoId ? { ...item, esVisible: checked } : item
                        )
                    );
                }
            }).catch((e) => {
                if (e.response?.data && 'type' in e.response.data) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    console.error(mensajeError);
                } else {
                }
            });
        }
    };

    // Ejecutar cuando se cambia el control
    useEffect(() => {
        if (control) {
            getEquipo();
            setControl(false);
        }
    }, [control]);

    return {
        filter2,
        onChangeComboFilter,
        resetFilter2,
        items,
        filter,
        setFilter,
        loading,
        pagination,
        handleResetUpdate,
        onChangeSearch,
        setSelectAllChecked,
        selectAllChecked,
        handleSelectAllChange,
        onChangeTake,
        _onkeyUpSearchTable,
        getEquipo,
        setControl,
        buscar
    };
};

export { UseEquipo };
